export default class DataFormatHelper {
  static payloadData = (
    data: any,
    antselects: string[],
    dates: {
      field: string;
      with_time: boolean;
    }[] = []
  ) => {
    dates.forEach((date) => {
      if (data[date.field]) {
        data[date.field] = data.with_time
          ? data[date.field].format("YYYY-MM-DD HH:mm:ss")
          : data[date.field].format("YYYY-MM-DD");
      }
    });

    antselects.forEach((antselect) => {
      if (data[antselect] && typeof data[antselect] === "object") {
        if (Array.isArray(data[antselect])) {
          data[antselect] = data[antselect].map((item: any) =>
            item.value ? item.value : item
          );
        } else {
          data[antselect] = data[antselect].value
            ? data[antselect].value
            : data[antselect];
        }
      }
    });

    return data;
  };
}
